
export type IPublicTypePreferenceValueType = string | number | boolean;
